import { useEffect } from "react";
import { connect } from "react-redux";
import abba from "ducks/abba";

export const mapStateToProps = (state) => ({
    isLoaded: state.abba && state.abba.isLoaded
});

export const mapDispatchToProps = (dispatch) => ({
    getAbbaConfig() {
        return dispatch(abba.getAbbaConfig());
    }
});

const AbbaWrapper = ({ children, getAbbaConfig, isLoaded }) => {
    useEffect(() => {
        if (isLoaded) {
            return;
        }

        getAbbaConfig();
    }, [getAbbaConfig, isLoaded]);

    return children;
};

export default connect(mapStateToProps, mapDispatchToProps)(AbbaWrapper);
